// extracted by mini-css-extract-plugin
export default {"toggle":"job-info-dropdown_toggle__mZvxi","arrow":"job-info-dropdown_arrow__c48NU","menu":"job-info-dropdown_menu__el+to"};